import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocialLeadsAutomationService {

  constructor(
    private _http: HttpClient
  ) { }

  addSociaLead(req: any, code: any): Observable<any> {
    return this._http.post(`${environment.public}/AddLeadForm/${code}`, req);
  }

  getLeadFormConfiguration(code: any): Observable<any> {
    return this._http.get(`${environment.inventory}/GetLeadFormConfigurationTemplate/${code}`);
  }

  addOrUpdateLeadFormConfiguration(formData: FormData): Observable<any> {
    return this._http.post(`${environment.inventory}/AddOrUpdateLeadFormConfigurationTemplate`, formData);
  }

  getLeadLookupCode(): Observable<any>{
    return this._http.get(`${environment.inventory}/GenerateLeadLookupCode`);
  }

  getLeadFormConfigurationFromCode(code: any): Observable<any> {
    return this._http.get(`${environment.public}/GetLeadFormConfigurationTemplate/${code}`);
  }

  getAllSocialTemplates(pageNo: number, pageSize: number, searchKeyword: string, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post(`${environment.inventory}/GetLeadFormConfigurationTemplates`,paginationSettings);
  }
}
